import { render, staticRenderFns } from "./modal-confirm.vue?vue&type=template&id=ea922af4&scoped=true"
import script from "./modal-confirm.vue?vue&type=script&lang=js"
export * from "./modal-confirm.vue?vue&type=script&lang=js"
import style0 from "./modal-confirm.vue?vue&type=style&index=0&id=ea922af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea922af4",
  null
  
)

export default component.exports